import { Command } from 'commander';
import { ConfigService } from '../../services/config.service.js';
import { StarterKitService } from '../../services/starter-kit.service.js';
import { ValidationError } from '../../errors/index.js';

export function createKitInfoCommand(): Command {
    return new Command('info')
        .description('Show detailed information about a starter kit')
        .argument('<slug>', 'Starter kit slug')
        .action(async (slug) => {
            const configService = new ConfigService();
            const config = await configService.load();

            if (!config) {
                throw new ValidationError('Not initialized. Run "jai1 auth" first.');
            }

            const kitService = new StarterKitService();
            const kit = await kitService.get(config, slug);

            console.log(`📦 ${kit.name}\n`);
            console.log(`Description: ${kit.description}`);
            console.log(`Category:    ${kit.category}`);
            console.log(`Version:     ${kit.version}`);
            console.log(`Downloads:   ${kit.downloads}`);

            if (kit.tags.length > 0) {
                console.log(`Tags:        ${kit.tags.join(', ')}`);
            }

            if (kit.config.requiredTools && kit.config.requiredTools.length > 0) {
                console.log(`\nRequired Tools:`);
                kit.config.requiredTools.forEach((tool) => {
                    console.log(`  - ${tool}`);
                });
            }

            if (kit.config.framework?.apply && kit.config.framework.components.length > 0) {
                console.log(`\nIncluded Framework Components:`);
                kit.config.framework.components.forEach((comp) => {
                    console.log(`  - ${comp}`);
                });
            }

            if (kit.config.variables && kit.config.variables.length > 0) {
                console.log(`\nVariables (prompted during creation):`);
                kit.config.variables.forEach((v) => {
                    console.log(`  - ${v.name}: ${v.prompt}${v.default ? ` (default: ${v.default})` : ''}`);
                });
            }

            if (kit.config.hooks?.postInit && kit.config.hooks.postInit.length > 0) {
                console.log(`\nPost-Init Commands:`);
                kit.config.hooks.postInit.forEach((cmd) => {
                    console.log(`  - ${cmd}`);
                });
            }
        });
}
